export const styles = (theme) => ({
    title: {
        "& h3": {
            margin: "1.5rem 0 0.5rem 0"
        }
    },
    rowDisplay: {
        display: "flex",
        flexDirection: "row" as const,
        alignItems: "center"
    },
    infoButton: {
        paddingBottom: 3
    }
});
